<template>
<div class="field__radio-buttons">
    <div class="control">
        <label class="checkbox"><input type="checkbox" :name="config.name" :value="config.value" :checked="config.checked" /> <span v-html="config.label"></span></label>
    </div>
    <p v-if="config.help" class="help">{{config.help}}</p>
</div>
</template>

<script>
export default {
    name    :   'Radio',
    props   :   ['config'],
    computed: {
        isWhitepaper() {
            return this.$parent ? this.$parent.$options.name == 'WhitepaperForm' : false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/formfields/Checkbox.vue